import { EmmaOccasionsForTenantQuery } from '@/generated/gql/graphql'
import { OccasionFields, OccasionFieldsAndEventDetails } from './types'
import { match } from 'ts-pattern'
import { occasions as feedrOccasions } from './feedr/occasions'
import { occasions as eatfirstOccasions } from './eatfirst/occasions'
import { occasions as feedwellOccasions } from './feedwell/occasions'
import { occasions as morsyOccasions } from './morsy/occasions'
import { occasions as mymycateringOccasions } from './mymycatering/occasions'

export const allOccasions = (
  tenantId: string,
  occasions: EmmaOccasionsForTenantQuery['emmaOccasions'],
): OccasionFields[] =>
  occasions.map((occasion) => {
    const commonFields: OccasionFields = {
      id: occasion.code,
      label: `emma:occasions_${occasion.code}`,
      fallbackLabel: occasion.name,
      active: null,
      skip: false,
      image: occasion.imageUrl || '',
      fields: [],
      eventDetails: [],
    }
    if (occasion.activeFrom && occasion.activeTo) {
      commonFields.active = {
        from: {
          month: occasion.activeFrom.month,
          day: occasion.activeFrom.day,
        },
        to: {
          month: occasion.activeTo.month,
          day: occasion.activeTo.day,
        },
      }
    }

    let result: OccasionFieldsAndEventDetails = {
      skip: false,
      fields: [],
      eventDetails: [],
    }

    match(tenantId)
      .with('64c934f210528b243cba6142', () => {
        result = feedrOccasions(occasion.code)
      })
      .with('64dc848494507001f38d8e6c', () => {
        result = eatfirstOccasions(occasion.code)
      })
      .with('64c9351947c111d57ab98ef7', () => {
        result = eatfirstOccasions(occasion.code)
      })
      .with('67289e1edd6cdd85ffe3ae7e', () => {
        result = feedwellOccasions(occasion.code)
      })
      .with('6785553d1ac47490a46b7310', () => {
        result = morsyOccasions(occasion.code)
      })
      .with('670fa10d073d99a16586e7ce', () => {
        result = mymycateringOccasions(occasion.code)
      })

    commonFields.skip = result.skip
    commonFields.fields = result.fields
    commonFields.eventDetails = result.eventDetails
    return commonFields
  })
